<template>
  <el-select v-if="isEditor" v-model="value" :placeholder="`请选择${item.fieldName}`" @change="mySubmit">
    <el-option
      v-for="item in source"
      :key="item.optional_value"
      :label="item.optional_label"
      :value="item.optional_value"
    />
  </el-select>
  <div v-else>{{ filterLabel(item.optionalValue, value) }}</div>
</template>
<script>
import { isJSON } from '@/utils'
import { defineComponent, computed } from 'vue'
import { baseProps, controlItemManage } from '../control-web/index'
export default defineComponent({
  name: 's-select',
  inheritAttrs: false,
  props: { ...baseProps, modelValue: { type: String } },
  emits: ['update:modelValue', 'my-change'],
  setup(props, context) {
    const source = computed(() => {
      if (props.item.optionalValue && isJSON(props.item.optionalValue)) {
        return JSON.parse(props.item.optionalValue)
      } else {
        return []
      }
    })
    //单选显示
    const filterLabel = (ops, value) => {
      if (!ops && !isJSON(ops)) return
      const options = JSON.parse(ops)
      let items = options.filter((it) => {
        return it.optional_value == value
      })
      if (items.length > 0) {
        return items[0].optional_label
      } else {
        return ''
      }
    }
    return {
      source,
      filterLabel,
      ...controlItemManage(props, context)
    }
  }
})
</script>
